import { render } from "./DisciplesEmmaiusDetails.vue?vue&type=template&id=050c7a7c&ts=true"
import script from "./DisciplesEmmaiusDetails.vue?vue&type=script&lang=ts"
export * from "./DisciplesEmmaiusDetails.vue?vue&type=script&lang=ts"

import "./DisciplesEmmaiusDetails.vue?vue&type=style&index=0&id=050c7a7c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__